import { showToast } from "@janeapp/burrito-design-system"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import {
  consumeKcActionSuccess,
  safeSessionStorage,
} from "../../helpers/kcActionResult"
import { PersonalInformation } from "./PersonalInformation"
import { RegisteredDevices } from "./RegisteredDevices"
import { SignInInformation } from "./SignInInformation"

// Keycloak actions which have a success-toast.
const SUCCESS_TOAST_KEYS: Record<string, string> = {
  UPDATE_PERSONAL_INFORMATION: "personalInformation.updateSuccess",
  UPDATE_PASSWORD_WITH_VERIFICATION: "loginSecurity.passwordUpdateSuccess",
}

export const AccountDetails = () => {
  const { t } = useTranslation()

  // On return from a completed Keycloak action, surface a success toast for the mapped actions.
  useEffect(() => {
    const completed = consumeKcActionSuccess(safeSessionStorage())
    const messageKey = completed ? SUCCESS_TOAST_KEYS[completed] : undefined
    if (messageKey) {
      showToast({
        tone: "success",
        isDismissible: true,
        content: t(messageKey),
      })
    }
  }, [t])

  return (
    <div className="flex flex-col gap-5">
      <PersonalInformation />
      <SignInInformation />
      <RegisteredDevices />
    </div>
  )
}
